import { RawButton } from '@ps/web-shared-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Error from '../Error/Error';
import type { IIdScanData } from '../sdk/idscan-jcs';
import sharedStyles from '../styles.scss';
import type { JourneyResultProp } from '../types';
import { hasError } from '../utils';

import {
  TXTCLI_Date_of_BirthX,
  TXTCLI_GenderX,
  TXTCLI_Retry,
  TXTSRV_First_NameX,
  TXTWCL_Confirm_your_details,
  TXTWCL_Document_NumberX,
  TXTWCL_Journey_has_not_been_completed_ELL,
  TXTWCL_Last_NameX,
  TXTWCL_Please_check_that_these_detail_ELL,
  TXTWCL_Please_click_Start_New_Journey_ELL,
  TXTWCL_Your_documents_have_not_been_v_ELL
} from './Result.messages.json';
import styles from './Result.scss';

type Props = JourneyResultProp & {
  journey: IIdScanData;
};

const Result: React.FC<Props> = ({
  journey: {
    documents,
    isFinished,
    person: { firstName, lastName, birthDate, gender }
  },
  journeyResult
}) => {
  const hasResultError = hasError(journeyResult);

  return (
    <>
      <Error journeyResult={journeyResult} />
      {!isFinished && (
        <>
          <h2 className={sharedStyles.title}>
            <FormattedMessage {...TXTWCL_Journey_has_not_been_completed_ELL} />
          </h2>
          <p>
            <FormattedMessage {...TXTWCL_Your_documents_have_not_been_v_ELL} />{' '}
            <FormattedMessage {...TXTWCL_Please_click_Start_New_Journey_ELL} />
          </p>
        </>
      )}
      {isFinished && !hasResultError && (
        <>
          <FormattedMessage tagName="h3" {...TXTWCL_Confirm_your_details} />
          <FormattedMessage tagName="p" {...TXTWCL_Please_check_that_these_detail_ELL} />
          <div className={styles.list}>
            <div>
              <FormattedMessage tagName="b" {...TXTSRV_First_NameX} />
              <span>{firstName}</span>
            </div>
            <div>
              <FormattedMessage tagName="b" {...TXTWCL_Last_NameX} />
              <span>{lastName}</span>
            </div>
            <div>
              <FormattedMessage tagName="b" {...TXTCLI_Date_of_BirthX} />
              <span>{birthDate}</span>
            </div>
            <div>
              <FormattedMessage tagName="b" {...TXTCLI_GenderX} />
              <span>{gender}</span>
            </div>
            <div>
              <FormattedMessage tagName="b" {...TXTWCL_Document_NumberX} />
              <span>{documents[documents.length - 1].number}</span>
            </div>
          </div>
        </>
      )}
      <form>
        <RawButton
          block
          variant="secondary"
          className={styles.button}
          data-jcs-element="result__journey__restart"
        >
          <FormattedMessage {...TXTCLI_Retry} />
        </RawButton>
      </form>
    </>
  );
};

export default Result;
